import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavItem } from '../models/navigation.model';
import { PracticeCasesService, Diagnosis, Case } from '../services/practice-cases.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Output() navigate = new EventEmitter<{section: string, title: string, data?: any}>();

  navItems: NavItem[] = [
    {
      id: 'overview',
      label: 'Overview',
      isActive: true,
      children: [
        { id: 'welcome', label: 'Welcome' },
        { id: 'general-info', label: 'General Info' },
        { id: 'general-approach', label: 'General approach' },
        { id: 'list-of-cases', label: 'List of cases' }
      ]
    },
    {
      id: 'practice-cases',
      label: 'Practice Cases',
      children: []
    },
    {
      id: 'interactive-cases',
      label: 'Interactive Cases'
    }
  ];

  diagnosisList: Diagnosis[] = [];
  allCases: Case[] = [];

  constructor(private practiceCasesService: PracticeCasesService) { }

  ngOnInit(): void {
    // Load practice cases from the API
    this.loadPracticeCases();

    // Initial navigation - select the first tab and its first child by default
    if (this.navItems.length > 0 && this.navItems[0].children && this.navItems[0].children.length > 0) {
      this.selectNavItem(this.navItems[0], this.navItems[0].children[0]);
    }
  }

  private loadPracticeCases(): void {
    this.practiceCasesService.getPracticeCases().subscribe((diagnosisList: Diagnosis[]) => {
      this.diagnosisList = diagnosisList;
      
      // Collect all cases
      this.allCases = [];
      let caseCounter = 1;
      
      diagnosisList.forEach((diagnosis: Diagnosis) => {
        diagnosis.cases.forEach((caseItem: Case) => {
          // Set a title if it doesn't exist
          if (!caseItem.case_title) {
            caseItem.case_title = `Case ${caseCounter++}`;
          }
          this.allCases.push(caseItem);
        });
      });

      // Update practice cases tab with dynamically loaded cases
      const practiceTab = this.navItems.find(item => item.id === 'practice-cases');
      if (practiceTab) {
        practiceTab.children = this.allCases.map((caseItem, index) => {
          return { 
            id: `case-${index + 1}`, 
            label: `Case ${index + 1}`,
            data: caseItem
          };
        });
      }
    });
  }

  toggleNavItem(item: NavItem): void {
    item.isActive = !item.isActive;
   
    // If we're activating a tab with no children, emit the navigation event
    if (item.isActive && (!item.children || item.children.length === 0)) {
      this.navigate.emit({
        section: item.id,
        title: item.label
      });
    }
    
    // If we're activating the list-of-cases, pass the diagnosis list data
    if (item.isActive && item.id === 'practice-cases') {
      this.navigate.emit({
        section: 'list-of-cases',
        title: 'Practice Cases',
        data: {
          diagnosisList: this.diagnosisList,
          allCases: this.allCases
        }
      });
    }
  }

  selectNavItem(parentItem: NavItem, childItem: NavItem): void {
    // If selecting a practice case, pass the case data to content component
    if (parentItem.id === 'practice-cases' && childItem.data) {
      this.navigate.emit({
        section: childItem.id,
        title: `${parentItem.label} - ${childItem.label}`,
        data: {
          caseItem: childItem.data,
          diagnosisList: this.diagnosisList,
          allCases: this.allCases
        }
      });
    } else {
      // Regular navigation without additional data
      this.navigate.emit({
        section: childItem.id,
        title: `${parentItem.label} - ${childItem.label}`
      });
    }
  }
}
